export function redirectToHome(auth: boolean): string {
  let path = '/home';

  if (auth) {
    path += `?upd=${new Date().getTime()}`;
  }

  return path;
}
